import useSWR, { SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { MarketingFolder } from '../../../providers/api/dtos';
import { getMarketingFolder } from '../../../providers/api/marketing/marketingProvider';

export const MARKETING_FOLDER_BY_ID_RID = '/marketing/folders/:id';

export default function useMarketingFolder(id?: string): SWRResponse<MarketingFolder, AxiosError> {
  return useSWR(
    id ? [MARKETING_FOLDER_BY_ID_RID, id] : null,
    () => getMarketingFolder(id!),
  );
}
